export const firebaseConfig = {
  apiKey: "AIzaSyB9-BrrieVHH3zN_-HfguqbJfZhJ9CVbiU",
  authDomain: "test-records-16cc8.firebaseapp.com",
  projectId: "test-records-16cc8",
  storageBucket: "test-records-16cc8.appspot.com",
  messagingSenderId: "376118270936",
  appId: "1:376118270936:web:43be2f88694bdd7fddf0ad",
};
